<template>
  <div class="p-the-page-g01 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <div class="p-the-page-g01__body">
          <div class="p-the-page-g01__inner">
            <p class="p-the-page-g01__heading">ランキング</p>
            <ul class="p-the-page-g01__tab">
              <li
                v-for="tab in tabs"
                :key="tab.value"
                class="p-the-page-g01__tab__item"
                :class="{ active: tab.value === active }"
                :style="{ 'border-color': colorCode }"
                @click="active = tab.value"
              >
                {{ tab.label }}
              </li>
            </ul>
          </div>
          <KeepAlive>
            <component :is="selectedContent" class="p-the-page-g01__content" />
          </KeepAlive>
        </div>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheG01ContentCategory from "@/general/components/pages/parts/Ranking/TheG01ContentCategory.vue";
import TheG01ContentPoint from "@/general/components/pages/parts/Ranking/TheG01ContentPoint.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { rankingByCategory, rankingByPoints } from "@/general/store/api";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheHeader,
    TheFooter,
    TheG01ContentCategory,
    TheG01ContentPoint,
    TheBreadcrumb
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  },
  watch: {
    active(){
      if (this.active == "point") {
        this.breadcrumb = [
          {
            text: "",
            url: "/home",
            pageType: "home"
          },
          {
            text: "ランキング" + " (ポイント別)",
            url: "",
            pageType: "lower"
          }
        ];
        commons.setbreadcrumb(this.breadcrumb);
      } else {
        this.breadcrumb = [
          {
            text: "",
            url: "/home",
            pageType: "home"
          },
          {
            text: "ランキング" + " (カテゴリー別)",
            url: "",
            pageType: "lower"
          }
        ];
        commons.setbreadcrumb(this.breadcrumb);
      }
    }
  }
})
export default class Ranking extends Vue {
  tabDefault = "category";

  tabs = [
    {
      label: "カテゴリー別",
      value: "category"
    },
    {
      label: "ポイント別",
      value: "point"
    }
  ];

  declare $refs: {
    theHeader: TheHeader;
  };

  breadcrumb: any = [];

  active = "";

  get selectedContent() {
    switch (this.active) {
      case "point":
        return "TheG01ContentPoint";
      default:
        return "TheG01ContentCategory";
    }
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.active = this.tabDefault;
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const active = this.active == "category" ? "カテゴリー別" : "ポイント別";

    this.breadcrumb = [
      {
        text: "",
        url: "/home",
        pageType: "home"
      },
      {
        text: "ランキング" + " (" + active + ")",
        url: "",
        pageType: "lower"
      }
    ];
    await commons.setbreadcrumb(this.breadcrumb);
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-g01 {
  background-color: $common-bg;

  &__body {
    padding: rem(56) 0;

    @include large-sp {
      padding: 0 0 rem(48);
    }
  }

  &__inner {
    max-width: rem(1200);
    margin: 0 auto;
  }

  &__heading {
    @include text__title--l;

    @include sp {
      @include text__title--m;
    }
  }

  &__tab {
    display: flex;
    border-bottom: px(1) solid $common-gray-border;
    margin-top: rem(24);

    @include large-sp {
      margin-top: rem(16);
    }

    &__item {
      @include text__body--s;
      color: $common-gray500;
      padding: 0 rem(4) rem(8);
      cursor: pointer;

      &.active {
        color: $common-black-sub;
        font-weight: bold;
        border-bottom-width: px(3);
        border-bottom-style: solid;
        cursor: default;
      }

      @include large-sp {
        width: 50%;
        text-align: center;
      }
    }
  }

  &__content {
    margin-top: rem(24);
  }
}
</style>
